import React, {useState} from "react";
import "./Nav.css";
const Nav = () => {
    const [showPopup, setShowPopup] = useState(false);
    return (
        <div>
            <header className="landing-header">
                <h1 className="landing-logo">ترسيخ</h1>
                <button className="landing-menu-button" onClick={() => setShowPopup(prev => !prev)}>☰</button>
            </header>
            <nav className={`landing-nav ${showPopup ? 'active' : ''}`}>
                <ul className="landing-nav-list">
                    {/* <li className="landing-nav-item"><a href="/home">الرئيسية</a></li> */}
                    {/* <li className="landing-nav-item"><a href="/memory">الحفظ</a></li> */}
                    {/* <li className="landing-nav-item"><a href="/quran">القرآن</a></li> */}
                    <li className="landing-nav-item"><a href="/">عن التطبيق</a></li>
                    <li className="landing-nav-item"><a href="/contact">تواصل معنا</a></li>
                    <li className="landing-nav-item sign-in"><a href="/login">تسجيل الدخول</a></li>
                    <li className="landing-nav-item sign-up"><a href="/login">انشاء حساب</a></li>
                </ul>
            </nav>

        </div>
    )
}

export default Nav;